import React from "react";

import { updateEmailConfig } from "@admin/api/config";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

type RefetchEmailConfig = () => Promise<unknown>;

export const usePutEmailConfig = (refetchEmailConfig?: RefetchEmailConfig) => {
    const [isLoading, setIsLoading] = React.useState(false);

    const onMutate = (values: API.EmailConfig) => {
        setIsLoading(true);
        void updateEmailConfig(values)
            .then(() => showSuccessToast("Email config updated successfully"))
            .then(() => refetchEmailConfig?.())
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err.message);
            })
            .finally(() => setIsLoading(false));
    };

    return { isLoading, onMutate };
};
